import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { MComparisonTable } from '../../molecules';

export default function OCompareTable({ product1, product2 }) {
	return (
		<section className="o-compare-table">
			<h2>
				<MComparisonTable id="PRODUCT_COMPARE.COMPARE_TABLE_TITLE" defaultProps="" />
			</h2>
			<MComparisonTable
				product1={product1}
				product2={product2}
			/>
		</section>
	);
}

MComparisonTable.propTypes = {
	product1: PropTypes.any.isRequired,
	product2: PropTypes.any,
};

MComparisonTable.defaultProps = {
	product2: undefined,
};



// WEBPACK FOOTER //
// ./src/components/organisme/compare/_organisme.compare-table.js